import { render, staticRenderFns } from "./UserInfoDetailComp.vue?vue&type=template&id=78edb5c6"
import script from "./UserInfoDetailComp.vue?vue&type=script&lang=js"
export * from "./UserInfoDetailComp.vue?vue&type=script&lang=js"
import style0 from "./UserInfoDetailComp.vue?vue&type=style&index=0&id=78edb5c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports